<template>
  <!-- Control-level gate: when every configured tile is unreachable the whole
       panel renders nothing (no dead widgets); the editor always shows it. -->
  <div v-if="editMode || tiles.length" class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
    </div>
    <div class="v3-tiles">
      <button
        v-for="(t, i) in tiles"
        :key="'tile' + i"
        type="button"
        class="v3-tile"
        v-testid="testid + '-row-' + (t.destination || t.label)"
        @click="go(t)"
      >
        <span class="v3-tile-ic" :class="`v3-tile-ic--${toneFor(t, i)}`"><span class="ms">{{ t.icon || 'chevron_right' }}</span></span>
        <span class="v3-tile-label">{{ t.label }}</span>
        <span v-if="t.sub" class="v3-tile-sub">{{ t.sub }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { canNavigateTo } from "@/composables/useV3Nav";

// New-portal (v3) Quick Links landing control — legacy/Vue 2 rendering. Renders
// the configured tiles (label · icon · destination) authored inline in the
// landing config dialog. Mirrors the beta QuickLinksWidget.
export default {
  name: "cLandingV3QuickLinks",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3QuickLinks";
    },
    title() {
      return this.definition.title || "Quick links";
    },
    // Legacy-landing-config parity: only surface tiles whose destination the
    // user can reach (route permission gate); the editor shows everything.
    tiles() {
      const all = this.definition.tiles || [];
      if (this.editMode) return all;
      return all.filter((t) => !t.destination || canNavigateTo(this, t.destination));
    },
  },
  methods: {
    // Per-tile icon tone, falling back to the prototype cycle when unset.
    toneFor(t, i) {
      const cycle = ["accent", "violet", "green"];
      return (t && t.tone) || cycle[i % cycle.length];
    },
    go(t) {
      if (this.editMode) return;
      const dest = t && t.destination;
      if (!dest) return;
      if (/^https?:\/\//i.test(dest)) {
        window.open(dest, "_blank");
        return;
      }
      const docTypes = Array.isArray(t.docTypes) ? t.docTypes : [];
      const statuses = Array.isArray(t.statuses) ? t.statuses : [];
      if (docTypes.length || statuses.length) {
        this.$passedParams.set({ docTypes, statuses });
      }
      this.$router.push({ name: dest }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
